import Box from '@mui/material/Box';
import Tooltip from '../Tooltip';
import { COLORS } from '../../theme';

const WARNING_MIN = 10;
const WARNING_MAX = 20;

function getGradient(progress: number) {
  if (progress <= WARNING_MIN) return COLORS.gradients.progressDanger;
  if (progress <= WARNING_MAX) return COLORS.gradients.progressWarning;
  return COLORS.gradients.progress;
}

export default function ProgressBar({ progress, tooltipTitle }: { progress: number; tooltipTitle?: string }) {
  return (
    <Tooltip title={tooltipTitle} placement="top">
      <Box sx={{ borderRadius: '8px', overflow: 'hidden', backgroundColor: COLORS.gray[650] }}>
        <Box sx={{ height: '8px', width: `${progress}%`, background: getGradient(progress) }} />
      </Box>
    </Tooltip>
  );
}
